/* eslint-disable vue/no-mutating-props */
<template>
  <div class="single-line-field w-full">
    <p for="input" class="block text-sm mb-2 font-semibold text-argus-forest-800">
      {{ field.label }}
      <span v-if="field.required" class="text-argus-error text-sm">*</span>
    </p>

    <div class="flex flex-row">
      <Dropdown
        :options="field.options"
        @select="updateValue"
        :placeholder="field.placeholder"
        dropDownSize="h-[150px]"
      />
    </div>

    <template v-if="field.error || !!errorMessage">
      <p class="text-argus-error text-sm py-[4px]">{{ errorMessage }}</p>
    </template>
    <template v-else-if="field.help_text">
      <p class="text-argus-forest-600 text-sm py-[4px]">{{ field.help_text }}</p>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    field: Object,
  },
  emits: ['update'],
  computed: {
    isValid() {
      if (!this.field.value && this.field.required) {
        return false
      }

      return true
    },
  },
  data() {
    return {
      touched: false,
      errorMessage: '',
      value: '',
    }
  },
  mounted() {
    if (this.field.value) {
      this.value = this.field.value
    }
  },
  methods: {
    updateValue(ev) {
      this.$emit('update', ev.value)
    },
    validateField() {
      if (!this.isValid) {
        if (this.field.required && !this.field.value) {
          this.errorMessage = 'This field is required.'
          return
        }
      } else {
        this.errorMessage = ''
      }
    },
  },
}
</script>
<style scoped>
input[type='text']:focus {
  outline: none;
  box-shadow: none;
}
</style>
